module.exports = __webpack_public_path__ + "fonts/Charlie_Text-Regular.b840082229ef67d26f10.woff";